import { AuthoringBlockType } from "common/constants";

import { ElementBlock } from "./ElementBlock";

export class CardsBlock extends ElementBlock {
    get type() {
        return AuthoringBlockType.CARDS;
    }
}
